import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";

// ✅ Import User Context Provider (from pages folder)
import { UserProvider } from "./pages/UserContext.js";

// ✅ Import Route Guards
import PrivateRoute from "./pages/Master/PrivateRoute.js";
import PublicRoute from "./pages/Master/PublicRoute.js";

// ✅ Import All Pages
import Login from "./pages/Login.js";
import Signup from "./pages/Signup.js";
import ForgotPassword from "./pages/ForgotPassword.js";
import Dashboard from "./pages/Dashboard.js";
import DesignationForm from "./pages/Master/DesignationForm.js";
import DesignationGrid from "./pages/Master/DesignationGrid.js";
import AccountMaster from "./pages/Master/Accountmaster.js";
import AccountMasterGrid from "./pages/Master/AccountmasterGrid.js";
import BankMaster from "./pages/Master/Bankmaster.js";
import BankmasterGrid from "./pages/Master/BankmasterGrid.js";
import CreditcardMaster from "./pages/Master/Creditcardmaster.js";
import CreditcardmasterGrid from "./pages/Master/CreditcardmasterGrid.js";
import Gstnaturemaster from "./pages/Master/Gstnaturemaster.js";
import GstnaturemasterGrid from "./pages/Master/GstnaturemasterGrid.js";
import Colormaster from "./pages/Master/Colormaster.js";
import ColormasterGrid from "./pages/Master/ColormasterGrid.js";
import Modelmaster from "./pages/Master/Modelmaster.js";
import ModelmasterGrid from "./pages/Master/ModelmasterGrid.js";
import Insurancemaster from "./pages/Master/Insurancemaster.js";
import InsurancemasterGrid from "./pages/Master/InsurancemasterGrid.js";
import Ratemaster from "./pages/Master/Ratemaster.js";
import RatemasterGrid from "./pages/Master/RatemasterGrid.js";
import RtoCityMaster from "./pages/Master/RtoCityMaster.js";
import RtoCityMasterGrid from "./pages/Master/RtoCityMasterGrid.js";
import RtoMaster from "./pages/Master/RtoMaster.js";
import RtoMasterGrid from "./pages/Master/RtoMasterGrid.js";
import SchemeMaster from "./pages/Master/SchemeMaster.js";
import SchemeMasterGrid from "./pages/Master/SchemeMasterGrid.js";
import Accessoriesmaster from "./pages/Master/Accessoriesmaster.js";
import AccessoriesmasterGrid from "./pages/Master/AccessoriesmasterGrid.js";
import PackageMaster from "./pages/Master/PackageMaster.js";
import PackageMasterGrid from "./pages/Master/PackageMasterGrid.js";
import CategoryMaster from "./pages/Master/CategoryMaster.js";
import CategoryMasterGrid from "./pages/Master/CategoryMasterGrid.js";
import StaffMaster from "./pages/Master/StaffMaster.js";
import StaffMasterGrid from "./pages/Master/StaffMasterGrid.js";
import Teammaster from "./pages/Master/Teammaster.js";
import Hypothecation from "./pages/Master/Hypothecation.js";
import HypothecationGrid from "./pages/Master/HypothecationGrid.js";
import FinanceexecutiveMaster from "./pages/Master/FinanceexecutiveMaster.js";
import FinanceexecutiveMasterGrid from "./pages/Master/FinanceexecutiveMasterGrid.js";
import FinanceMaster from "./pages/Master/FinanceMaster.js";
import FinanceMasterGrid from "./pages/Master/FinanceMasterGrid.js";
import OtherMaster from "./pages/Master/OtherMaster.js";
import OtherMasterGrid from "./pages/Master/OtherMasterGrid.js";
import ReasonMaster from "./pages/Master/ReasonMaster.js";
import ReasonMasterGrid from "./pages/Master/ReasonMasterGrid.js";
import WarrantyMaster from "./pages/Master/WarrantyMaster.js";
import WarrantyMasterGrid from "./pages/Master/WarrantyMasterGrid.js";
import SotMaster from "./pages/Master/SotMaster.js";
import SotMasterGrid from "./pages/Master/SotMasterGrid.js";
import ExpCategoryMaster from "./pages/Master/ExpCategoryMaster.js";
import ExpCategoryMasterGrid from "./pages/Master/ExpCategoryMasterGrid.js";
import ExpAllowMaster from "./pages/Master/ExpAllowMaster.js";
import ExpAllowMasterGrid from "./pages/Master/ExpAllowMasterGrid.js";
import RajaReceipt from "./pages/Sales/RajaReceipt.js";
import RajaReceiptGrid from "./pages/Sales/RajaReceiptGrid.js";
import ChequeReceipt from "./pages/CashBook/ChequeReceipt.js";
import HpnLetter from "./pages/Sales/HpnLetter.js";
import BookingApproval from "./pages/Booking/BookingApproval.js";
import VehicleAllocation from "./pages/Booking/VehicleAllocation.js";
import VehicleAllocationGrid from "./pages/Booking/VehicleAllocationGrid.js";
import BookingDocket from "./pages/Booking/BookingDocket.js";
import BookingDocketGrid from "./pages/Booking/BookingDocketGrid.js";
import BookingCancel from "./pages/Booking/BookingCancel.js";
import BookingChangeModel from "./pages/Booking/BookingChangeModel.js";
import Challan from "./pages/Inventory/Challan.js";

function App() {
  return (
    // ✅ Wrap your app in UserProvider (for session management)
    <UserProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* 🔓 Public Routes */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/forgot-password"
              element={
                <PublicRoute>
                  <ForgotPassword />
                </PublicRoute>
              }
            />
            <Route
              path="/signup"
              element={
                <PublicRoute>
                  <Signup />
                </PublicRoute>
              }
            />

            {/* 🔒 Private Routes */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />

            {/* Designation Routes */}
            <Route
              path="/designations"
              element={
                <PrivateRoute>
                  <DesignationGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/designation-form"
              element={
                <PrivateRoute>
                  <DesignationForm />
                </PrivateRoute>
              }
            />

            {/* Account Master */}
            <Route
              path="/accounts"
              element={
                <PrivateRoute>
                  <AccountMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/accounts/grid"
              element={
                <PrivateRoute>
                  <AccountMasterGrid />
                </PrivateRoute>
              }
            />

            {/* Bank Master */}
            <Route
              path="/bank"
              element={
                <PrivateRoute>
                  <BankMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/bank/grid"
              element={
                <PrivateRoute>
                  <BankmasterGrid />
                </PrivateRoute>
              }
            />

            {/* Credit Card Master */}
            <Route
              path="/creditcard"
              element={
                <PrivateRoute>
                  <CreditcardMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/Creditcard/grid"
              element={
                <PrivateRoute>
                  <CreditcardmasterGrid />
                </PrivateRoute>
              }
            />

            {/* GST Master */}
            <Route
              path="/Gst"
              element={
                <PrivateRoute>
                  <Gstnaturemaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/Gst/grid"
              element={
                <PrivateRoute>
                  <GstnaturemasterGrid />
                </PrivateRoute>
              }
            />

            {/* Color Master */}
            <Route
              path="/Color"
              element={
                <PrivateRoute>
                  <Colormaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/Color/grid"
              element={
                <PrivateRoute>
                  <ColormasterGrid />
                </PrivateRoute>
              }
            />

            {/* Model Master */}
            <Route
              path="/Modelmaster"
              element={
                <PrivateRoute>
                  <Modelmaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/Modelmaster/grid"
              element={
                <PrivateRoute>
                  <ModelmasterGrid />
                </PrivateRoute>
              }
            />

            {/* Insurance Master */}
            <Route
              path="/Insurancemaster"
              element={
                <PrivateRoute>
                  <Insurancemaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/Insurancemaster/grid"
              element={
                <PrivateRoute>
                  <InsurancemasterGrid />
                </PrivateRoute>
              }
            />

            {/* Rate Master */}
            <Route
              path="/Ratemaster"
              element={
                <PrivateRoute>
                  <Ratemaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/RatemasterGrid"
              element={
                <PrivateRoute>
                  <RatemasterGrid />
                </PrivateRoute>
              }
            />

            {/* RTO City Master */}
            <Route
              path="/RtoCityMaster"
              element={
                <PrivateRoute>
                  <RtoCityMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/RtoCityMasterGrid"
              element={
                <PrivateRoute>
                  <RtoCityMasterGrid />
                </PrivateRoute>
              }
            />
            {/* RTO  Master */}
            <Route
              path="/RtoMaster"
              element={
                <PrivateRoute>
                  <RtoMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/RtoMasterGrid"
              element={
                <PrivateRoute>
                  <RtoMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/SchemeMaster"
              element={
                <PrivateRoute>
                  <SchemeMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/SchemeMasterGrid"
              element={
                <PrivateRoute>
                  <SchemeMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/Accessoriesmaster"
              element={
                <PrivateRoute>
                  <Accessoriesmaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/AccessoriesmasterGrid"
              element={
                <PrivateRoute>
                  <AccessoriesmasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/PackageMaster"
              element={
                <PrivateRoute>
                  <PackageMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/PackageMasterGrid"
              element={
                <PrivateRoute>
                  <PackageMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/CategoryMaster"
              element={
                <PrivateRoute>
                  <CategoryMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/CategoryMasterGrid"
              element={
                <PrivateRoute>
                  <CategoryMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/StaffMaster"
              element={
                <PrivateRoute>
                  <StaffMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/StaffMasterGrid"
              element={
                <PrivateRoute>
                  <StaffMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/Teammaster"
              element={
                <PrivateRoute>
                  <Teammaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/Hypothecation"
              element={
                <PrivateRoute>
                  <Hypothecation />
                </PrivateRoute>
              }
            />
            <Route
              path="/HypothecationGrid"
              element={
                <PrivateRoute>
                  <HypothecationGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/FinanceexecutiveMaster"
              element={
                <PrivateRoute>
                  <FinanceexecutiveMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/FinanceexecutiveMasterGrid"
              element={
                <PrivateRoute>
                  <FinanceexecutiveMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/FinanceMaster"
              element={
                <PrivateRoute>
                  <FinanceMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/FinanceMasterGrid"
              element={
                <PrivateRoute>
                  <FinanceMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/OtherMaster"
              element={
                <PrivateRoute>
                  <OtherMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/OtherMasterGrid"
              element={
                <PrivateRoute>
                  <OtherMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/ReasonMaster"
              element={
                <PrivateRoute>
                  <ReasonMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/ReasonMasterGrid"
              element={
                <PrivateRoute>
                  <ReasonMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/WarrantyMaster"
              element={
                <PrivateRoute>
                  <WarrantyMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/WarrantyMasterGrid"
              element={
                <PrivateRoute>
                  <WarrantyMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/SotMaster"
              element={
                <PrivateRoute>
                  <SotMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/SotMasterGrid"
              element={
                <PrivateRoute>
                  <SotMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/ExpCategoryMaster"
              element={
                <PrivateRoute>
                  <ExpCategoryMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/ExpCategoryMasterGrid"
              element={
                <PrivateRoute>
                  <ExpCategoryMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/ExpAllowMaster"
              element={
                <PrivateRoute>
                  <ExpAllowMaster />
                </PrivateRoute>
              }
            />
            <Route
              path="/ExpAllowMasterGrid"
              element={
                <PrivateRoute>
                  <ExpAllowMasterGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/RajaReceipt"
              element={
                <PrivateRoute>
                  <RajaReceipt />
                </PrivateRoute>
              }
            />
            <Route
              path="/RajaReceiptGrid"
              element={
                <PrivateRoute>
                  <RajaReceiptGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/ChequeReceipt"
              element={
                <PrivateRoute>
                  <ChequeReceipt />
                </PrivateRoute>
              }
            />
            <Route
              path="/HpnLetter"
              element={
                <PrivateRoute>
                  <HpnLetter />
                </PrivateRoute>
              }
            />
            <Route
              path="/BookingApproval"
              element={
                <PrivateRoute>
                  <BookingApproval />
                </PrivateRoute>
              }
            />
            <Route
              path="/VehicleAllocation"
              element={
                <PrivateRoute>
                  <VehicleAllocation />
                </PrivateRoute>
              }
            />
            <Route
              path="/VehicleAllocationGrid"
              element={
                <PrivateRoute>
                  <VehicleAllocationGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/BookingDocket"
              element={
                <PrivateRoute>
                  <BookingDocket />
                </PrivateRoute>
              }
            />
            <Route
              path="/BookingDocketGrid"
              element={
                <PrivateRoute>
                  <BookingDocketGrid />
                </PrivateRoute>
              }
            />
            <Route
              path="/BookingCancel"
              element={
                <PrivateRoute>
                  <BookingCancel />
                </PrivateRoute>
              }
            />
            <Route
              path="/BookingChangeModel"
              element={
                <PrivateRoute>
                  <BookingChangeModel />
                </PrivateRoute>
              }
            />
            <Route
              path="/Challan"
              element={
                <PrivateRoute>
                  <Challan />
                </PrivateRoute>
              }
            />

            {/* ✅ Default Redirect */}
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </UserProvider>
  );
}

export default App;
